import React from 'react';

interface KeyboardParentProps {
	children?: React.ReactNode;
}

interface KeyboardListEntryProps {
	title: string;
	children?: React.ReactNode;
}

export function KeyboardKey(props: KeyboardParentProps) {
	return <span className="keyboard-key">{props.children}</span>;
}

export default function KeyboardListEntry({
	title,
	children,
}: KeyboardListEntryProps) {
	return (
		<>
			<dt>{title}</dt>
			<dd>
				<div className="keyboard-group">
					{children}
				</div>
			</dd>
		</>
	);
}
